import styled from 'styled-components';
import { LogoColor, MathDepLogo } from '../../../common/header/MathDepLogo';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../../../routes/routes.config';

const SideBar = styled.div`
  height: 100vh;
  width: 224px;
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  background: linear-gradient(180deg, #0b68fe 0%, #0a5be3 100%);
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
`;

const SideBarContent = styled.div`
  height: 100%;
  width: 100%;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
`;

const LogoContainer = styled.div`
  width: 140px;
  height: 60px;
  margin: 0 52px 0 32px;
`;

const NavContainer = styled.nav`
  margin-top: 30px;
  padding-left: 20px;
  display: grid;
  gap: 10px;
`;

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #fff;
  padding: 12px 10px;
  border-radius: 8px;
  transition: 0.25s ease;
  &.active { background: rgba(255,255,255,0.12); font-weight: 600; }
  &:hover { background: rgba(255,255,255,0.08); }
`;

const Icon = styled.img`
  width: 18px;
  height: 18px;
`;

export const AdminSideBar = () => {
  const items = [
    { title: 'Дашборд', path: ROUTES.admin.dashboard.fullPath, icon: require('../../../../assets/icons/main/note.svg').default },
    { title: 'Пользователи', path: ROUTES.admin.users.fullPath, icon: require('../../../../assets/icons/people-outline.svg').default },
    { title: 'Преподаватели', path: '/admin/teachers', icon: require('../../../../assets/icons/people-outline.svg').default },
    { title: 'Потоки', path: ROUTES.admin.groups.fullPath, icon: require('../../../../assets/icons/book-open.svg').default },
    { title: 'Группы ИСУ', path: ROUTES.admin.isuGroups.fullPath, icon: require('../../../../assets/icons/people-outline.svg').default },
    { title: 'Мероприятия', path: '/admin/events', icon: require('../../../../assets/icons/main/calendar.svg').default },
    { title: 'Попытки', path: ROUTES.admin.attempts.fullPath, icon: require('../../../../assets/icons/file-text.svg').default },
  ];

  return (
    <SideBar>
      <SideBarContent>
        <LogoContainer>
          <MathDepLogo color={LogoColor.WHITE} />
        </LogoContainer>
        <NavContainer>
          {items.map(i => (
            <StyledNavLink key={i.title} to={i.path} end>
              <Icon src={i.icon} />
              <span>{i.title}</span>
            </StyledNavLink>
          ))}
        </NavContainer>
      </SideBarContent>
    </SideBar>
  );
};


